import { ISvgIconProps, } from '@Assets/icons/interface';
import { SvgIcon, } from '@Assets/icons/SvgIcon';
import React from 'react';

export const LiveIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <circle cx="12" cy="12" r="8" stroke='transparent' fill="red"></circle>
  </SvgIcon>;
};
